exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footerClass {\n  background-color: #FFF;\n  text-align: center;\n  color: white;\n  position: absolute;\n  bottom: 5px;\n  width: 100%;\n  display:block!important;\n  max-height: 160px;\n}\n\n.imagen1 {\n  max-width: 400px;\n}\n", ""]);

// exports
